import { FormControlLabel, FormControlLabelProps } from '@mui/material'
import { SwitchBase } from './SwitchBase'
import useTextStyles from 'styles/useTextStyles'

interface SwitchCustomProps {
  label: string
  disabled?: boolean
  labelProps?: Omit<FormControlLabelProps, 'control' | 'label'>
  checked?: boolean
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined
}
const SwitchCustom = ({
  label,
  disabled,
  labelProps,
  checked = false,
  onChange
}: SwitchCustomProps) => {
  return (
    <FormControlLabel
      title={label || ''}
      control={
        <SwitchBase title={label} checked={checked} onChange={onChange} disabled={disabled} />
      }
      label={label}
      {...labelProps}
      sx={{
        marginLeft: '0px',
        marginRight: '20px',
        '& .MuiFormControlLabel-label': { ...useTextStyles.bodyLarge, marginLeft: '20px' }
      }}
    />
  )
}

export default SwitchCustom
